module.exports = __webpack_public_path__ + "img/NO937894260.913340c1.png";